import type { AdminRole } from '@bravo/shared';
import { useQuery } from '@tanstack/react-query';
import { ApiError, apiData } from './api';

export interface AdminSession {
  id: string;
  email: string;
  name: string;
  role: AdminRole;
  totpEnabled: boolean;
  mustChangePassword: boolean;
  stage: 'enroll' | 'full';
}

export function useSession() {
  return useQuery({
    queryKey: ['me'],
    queryFn: async (): Promise<AdminSession | null> => {
      try {
        return await apiData<AdminSession>('/admin/me');
      } catch (error) {
        if (error instanceof ApiError && error.status === 401) return null;
        throw error;
      }
    },
    retry: false,
  });
}
